import React, { FC } from "react";
import { Typography } from "@material-ui/core";
import pretty from "Shared/pretty";
import { DPEmployeeProfile, EmploymentStatus } from "Shared/types/EmployeeProfiles";
import DataTable from "Components/Shared/DataTable/DataTable";
import DataTableRow from "Components/Shared/DataTable/DataTableRow/DataTableRow";
import useStyles from "./styles";

type Props = {
  partnerCanceledAt: DPEmployeeProfile["partnerCanceledAt"];
  employee: DPEmployeeProfile["employee"];
}

const StatusTable: FC<Props> = ({
  partnerCanceledAt,
  employee,
}) => {
  const classes = useStyles();
  const employmentStatus = partnerCanceledAt
    ? EmploymentStatus.TERMINATED
    : EmploymentStatus.EMPLOYED;

  const employmentStatusStyle =
    employmentStatus === "terminated" ? classes.terminated : classes.detail;

  return (
    <DataTable title="Status">
      <DataTableRow>
        <Typography>Employment Status:</Typography>
        <Typography className={employmentStatusStyle}>
          {pretty.titleizeWord(employmentStatus)}
        </Typography>
      </DataTableRow>
      <DataTableRow>
        <Typography>DailyPay Status:</Typography>
        <Typography className={classes.detail}>
          {pretty.titleizeWord(employee.userStatus)}
        </Typography>
      </DataTableRow>
    </DataTable>
  );
};

export default StatusTable;
